import NavigateRightIcon from '@/app/icons/navigate-right'
import { HeaderRow } from '@/components/sections'
import { GiphyFetch } from '@giphy/js-fetch-api'
import { Carousel } from '@giphy/react-components'
import Link from 'next/link'
import { useContext, useEffect } from 'react'
import { BodyScrollLockContext } from '..'
import { relativeGifClick, useClientSideAPIKey } from '../../../util/url'

const trendingCarouselHeight = 115

const TrendingCarousel = () => {
    const giphyFetch = new GiphyFetch(useClientSideAPIKey())
    const trending = (offset: number) => giphyFetch.trending({ offset })
    const { setIgnoreTarget } = useContext(BodyScrollLockContext)
    useEffect(() => {
        setIgnoreTarget(`.${Carousel.className}`)
        return () => setIgnoreTarget('')
    }, [setIgnoreTarget])
    return (
        <>
            <Link href="/trending-gifs">
                <HeaderRow className="mt-2 flex items-center gap-2">
                    <h4 className="text-giphyWhite">Trending Gifs</h4>
                    <NavigateRightIcon height={10} />
                </HeaderRow>
            </Link>
            <Carousel
                gifHeight={trendingCarouselHeight}
                fetchGifs={trending}
                onGifClick={relativeGifClick}
                hideAttribution
            />
        </>
    )
}
export default TrendingCarousel
